import React from "react";
//#region types
import { SimpleDatePickerProps } from "models/propTypes/datepickerPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import SimpleDatePicker from "./simpleDatePicker";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const InlineLabelDatePicker: React.FC<SimpleDatePickerProps> = (props) => {
  return (
    <SimpleDatePicker
      {...props}
      inputFormat={props.inputFormat ?? "dd MMM"}
      label={""}
      keyboardIcon={
        <div>
          <Icon icon={IconDefinitionConstants.WMonthCalendar} className={cssExports.inputIcon} />
          <span>{props.label}</span>
        </div>
      }
      className={cssExports.wizardHeaderField}
    />
  );
};

export default InlineLabelDatePicker;
